import React, { ReactNode, createContext, useContext } from 'react';

// * Communications Types.
// *
// * CRM - for customer communications
// * RECRUITMENT - for employee communications
// *
export enum CommunicationsType {
  CRM = 'crm',
  RECRUITMENT = 'recruitment',
}

export const COMMUNICATION_TYPES = [
  CommunicationsType.CRM,
  CommunicationsType.RECRUITMENT,
];

export type TCommunicationsTypeCtx = { communicationType: CommunicationsType };

export const CommunicationsTypeCtx =
  createContext<TCommunicationsTypeCtx | null>(null);

export const CommunicationsTypeCtxProvider = ({
  communicationType,
  children,
}: {
  communicationType: CommunicationsType;
  children: ReactNode;
}) => {
  return (
    <CommunicationsTypeCtx.Provider value={{ communicationType }}>
      {children}
    </CommunicationsTypeCtx.Provider>
  );
};

export const useCommunicationsTypeCtx = (): TCommunicationsTypeCtx => {
  const ctx = useContext(CommunicationsTypeCtx);

  if (!ctx) {
    throw new Error(
      'useCommunicationsTypeCtx must be used within a CommunicationsTypeCtx'
    );
  }

  return ctx;
};
